import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    offerMeal: null,
    soldOut: null,
    updateOfferMealId: null,
    visible: false,
    priceFormatted: null,
    packagingPriceFormatted: null,
    valid: true,
    errors: [],
  },
  mutations: mutations,
  actions: actions,
  getters: getters
}
